import React from 'react';
import { Box } from '../Box';

export function LeftChevron({ width = '50px', height = '50px', color = '#000' }) {
    return (
        <Box as="svg" x="0px" y="0px" width={width} height={height} viewBox="0 0 256 256" fill={color}>
            <polygon points="207.093,30.187 176.907,0 48.907,128 176.907,256 207.093,225.813 109.28,128"/>
        </Box>
    );
}